module.exports = __webpack_public_path__ + "img/logotipo.111fa6f0.svg";